import React from "react";
import { useTranslation } from "react-i18next";
import EAAlert from "../shared/EAAlert";
import EAButton from "../shared/Buttons/EAButton";

interface IProps {
  onGoToShop: () => void;
}

const SuccessStep: React.FC<IProps> = ({ onGoToShop }) => {
  const { t } = useTranslation();

  return (
    <>
      <h1>{t("sukces")}</h1>

      <div className="success-container">
        <EAAlert message={t("sukces_konta_uczestnikow_zostaly_zalozone")} type="success" />
        <EAButton title={t("przejdz_do_sklepu")} onClick={onGoToShop} fullWidth />
      </div>
    </>
  );
};

export default SuccessStep;

